import React from 'react';

import styled from 'styled-components';

const Container = styled.div`
    width: 90%;
    height: 90%;
    background: #F5F5F5;
    padding: 3.5% 5%;
    border-radius: 5px;
`

function Sales(){
    return(
        <Container>
            
        </Container>
    );
};

export default Sales;